import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import BasicModal from 'components/modals/BasicModal/BasicModal';
import GalleryItem from 'modules/getTheLook/components/GalleryItem';
import { inspirationImageShape } from 'modules/inspirationImage/propTypes';
import ImageLink from 'components/imageThumbnails/ImageLink';
import classes from './SingleInspirationModal.module.scss';

const SingleInspirationModal = ({ open, onClose, currentImage }) => {
  return (
    <BasicModal
      onClose={onClose}
      open={open}
      // fullWidth
      // maxWidth="md"
      classes={{ closeBtn: '' }}
    >
      <div>
        <h3 className="text-xl text-center font-title text-uppercase">
          Inspiration image
        </h3>
        {currentImage && (
          <div className={clsx(classes.imageWrapper)}>
            {/* eslint-disable-next-line */}
            {currentImage.source_url && (
              <div
                className={clsx(
                  classes.selectedImageLink,
                  'text-ellipsis',
                  'mb-3'
                )}
              >
                {/* eslint-disable-next-line */}
                <ImageLink url={currentImage?.source_url} color="white" />
              </div>
            )}
            <GalleryItem image={currentImage} isShowcase />
          </div>
        )}
      </div>
    </BasicModal>
  );
};

SingleInspirationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentImage: inspirationImageShape.isRequired,
};
export default SingleInspirationModal;
